import { create } from "zustand";
import { devtools } from "zustand/middleware";

interface PopupStore {
    //안내,알림 팝업
    confirmPop: boolean;
    confirmPopTit: string;
    confirmPopTxt: string;
    confirmPopBtn: number | null;
    setConfirmPop: (show: boolean, tit: string, txt: string, btn: number | null) => void;

    //로딩팝업
    loadingPop: boolean;
    setLoadingPop: (show: boolean) => void;
}

export const usePopupStore = create<PopupStore>()(
    devtools(set => ({
        //안내,알림 팝업 기본 상태
        confirmPop: false,
        confirmPopTit: "",
        confirmPopTxt: "",
        confirmPopBtn: null,

        //안내,알림 팝업 상태 변경 함수
        setConfirmPop: (show, tit, txt, btn) => set({ confirmPop: show, confirmPopTit: tit, confirmPopTxt: txt, confirmPopBtn: btn }),

        //로딩팝업 기본 상태
        loadingPop: false,

        //로딩팝업 상태 변경 함수
        setLoadingPop: show => set({ loadingPop: show }),
    })),
);
